import { Component } from '@angular/core';
import { BaseDetailPageComponent } from 'src/app/components/pages/base-detail-page/base-detail-page.component';
import BaseDetailPageConfig from 'src/app/models/base-detail-page.config';
import { ProposalsService } from 'src/app/services/api/proposals.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-payment-terms-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './payment-terms-detail-page.component.html',
  styleUrl: './payment-terms-detail-page.component.scss'
})
export class PaymentTermsDetailPageComponent {
  baseDetailPageConfig!: BaseDetailPageConfig;
  readonlyUserDetail: boolean

  paymentTerm?: any;

  constructor(
    private proposalsService: ProposalsService,
    private routeService: RouteService
  ) {
    this.readonlyUserDetail = true
  }

  ngOnInit(): void {

    this.baseDetailPageConfig = {
      pageTitle: 'Payment Term',
      cardTitle: 'Payment Term Detail',
      editItemButton: {
        type: 'success',
        title: 'Edit Payment Term',
        onClick: () => {
          this.routeService.proposalPaymentTermsUpdate(this.paymentTerm.proposalPaymentConditionTypeId);
        }
      },
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'code',
            label: 'Code',
            value: (item: any) => {
              return item.code;
            }
          },
          {
            attribute: 'name',
            label: 'Name',
            value: (item: any) => {
              return item.name;
            }
          },
          {
            attribute: 'position',
            label: 'Position',
            value: (item: any) => {
              return item.position;
            }
          },
        ]
      },
      apiDetailService: (paymentTermId: number) => this.proposalsService.detailSettingsPaymentTerms(paymentTermId),
      routeParamName: 'paymentTermId',
      responseModelName: 'proposalPaymentConditionType',
    };

  }

  onLoadedDetail(data: any) {
    this.paymentTerm = data;
  }
}
